export default __webpack_public_path__ + "static/media/Blade's Bracers of the Black Arts.31be509a.jpg";